import React from 'react';
import ReactDOM from 'react-dom/client';
import MainRouter from './routes/MainRouter';
import { PrimeReactProvider, addLocale, locale } from 'primereact/api';
import './index.scss'
addLocale('es', {
    startsWith: 'Comienza con',
    contains: 'Contiene',
    notContains: 'No contiene',
    endsWith: 'Termina con',
    equals: 'Igual a',
    notEquals: 'Diferente a',
    noFilter: 'Sin filtro',
    filter: 'Filtrar',
    lt: 'Menor que',
    lte: 'Menor o igual que',
    gt: 'Mayor que',
    gte: 'Mayor o igual que',
    dateIs: 'Fecha igual a',
    dateIsNot: 'Fecha diferente a',
    dateBefore: 'Antes de',
    dateAfter: 'Después de',
    clear: 'Limpiar',
    apply: 'Aplicar',
    matchAll: 'Coincidir todo',
    matchAny: 'Coincidir alguno',
    addRule: 'Agregar regla',
    removeRule: 'Eliminar regla',
    accept: 'Sí',
    reject: 'No',
    choose: 'Elegir',
    upload: 'Subir',
    cancel: 'Cancelar',
    today: 'Hoy',
    emptyMessage: 'Sin resultados',
    emptyFilterMessage: 'Sin resultados',
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    dayNamesMin: ['D', 'L', 'Ma', 'Mi', 'J', 'V', 'S'],
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    firstDayOfWeek: 1,
    dateFormat: 'dd/mm/yy',
    weekHeader: 'Sem',
    passwordPrompt: 'Ingrese una contraseña',
});
locale('es');


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PrimeReactProvider value={{ ripple: true }}>
    {/* <React.StrictMode> */}
      <MainRouter></MainRouter>
    {/* </React.StrictMode> */}
  </PrimeReactProvider>
);